const _humanizeDuration = require("humanize-duration");

function refresh() {
  location.reload();
}

function logout() {
  http.post("/logout")
    .then(() => {
      refresh();
    })
    .catch(() => {
      window.location.href = "/";
    });
}

function uuid(n = 12) {
  let text = "";
  let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (let i = 0; i < n; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  return text;
}

function humanizeDuration(duration, options = { largest: 2 }) {
  return _humanizeDuration(duration, _.merge({ language: window.Laravel.app.locale, round: true }, options));
}

function getDistanceFromLatLonInMeters(lat1, lon1, lat2, lon2) {
  var R = 6371000; // Radius of the earth in km
  var dLat = deg2rad(lat2 - lat1);  // deg2rad below
  var dLon = deg2rad(lon2 - lon1);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2)
    ;
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; // Distance in km
  return d;
}

function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

function toSIUnit(num, digits = 1) {
  var si = [
    { value: 1, symbol: "" },
    { value: 1E3, symbol: "k" },
    { value: 1E6, symbol: "M" },
    { value: 1E9, symbol: "G" },
    { value: 1E12, symbol: "T" },
    { value: 1E15, symbol: "P" },
    { value: 1E18, symbol: "E" }
  ];
  var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var i;
  for (i = si.length - 1; i > 0; i--) {
    if (num >= si[i].value) {
      break;
    }
  }
  return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
}

window.refresh = refresh;
window.logout = logout;
window.uuid = uuid;

window.humanizeDuration = humanizeDuration;

function fillFields(template, data) {
  const filledTemplate = {};

  Object.keys(template).forEach(key => {
    if (data[key] !== undefined) {
      filledTemplate[key] = _.cloneDeep(data[key]);
    } else {
      filledTemplate[key] = _.cloneDeep(template[key]);
    }
  });

  return filledTemplate;
}

function getAddressCityFromFeature(address) {
  if (!address) {
    return "";
  }

  let city = address.place_name ?? "";

  city = city.split(",")[1];

  return city;
}

function getAddressShortDescriptionFromFeature(address) {
  if (!address) {
    return "";
  }

  const number = address.address ?? "";
  const street = address.text ?? "";

  let city = getAddressCityFromFeature(address);

  return `${number} ${street}, ${city}`;
}

export { uuid, logout, refresh, humanizeDuration, fillFields, getAddressShortDescriptionFromFeature, getAddressCityFromFeature, getDistanceFromLatLonInMeters, toSIUnit };

/*
|--------------------------------------------------------------------------
| String Helpers
|--------------------------------------------------------------------------
*/

/** Capitalize */
String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

/** Truncate string */
String.prototype.limit = function (count) {
  return this.slice(0, count) + (this.length > count ? "..." : "");
};

/** Phone Format */
String.prototype.phoneFormat = function (n = 2) {
  let cleaned = ("" + this).replace(/\D/g, "");
  let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    let intlCode = (match[1] ? "+1 " : "");
    return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
  }
  return null;
};

/*
|--------------------------------------------------------------------------
| Number Helpers
|--------------------------------------------------------------------------
*/

/** Number Format */
Number.prototype.format = function (n = undefined) {
  new Intl.NumberFormat(Laravel.app.locale, { minimumFractionDigits: n, maximumFractionDigits: n }).format(this);
};

/** Percentage Format */
Number.prototype.percentageFormat = function (n = undefined) {
  return new Intl.NumberFormat(Laravel.app.locale, { style: "percent", minimumFractionDigits: n, maximumFractionDigits: n }).format(this);
};

/** Price Format */
Number.prototype.priceFormat = function (n = 2) {
  return new Intl.NumberFormat(Laravel.app.locale, { style: "currency", currency: "CAD", minimumFractionDigits: n, maximumFractionDigits: n }).format(this);
};

Number.prototype.fileSizeFormat = function () {
  let i = Math.floor(Math.log(this) / Math.log(1024));
  return (this / Math.pow(1024, i)).toFixed(2) * 1 + " " + ["B", "kB", "MB", "GB", "TB"][i];
};

/*
|--------------------------------------------------------------------------
| Date Helpers
|--------------------------------------------------------------------------
*/

/** Date to String */
Date.prototype.format = function () {
  let date = new Date(this.getTime());
  let month = "" + (date.getMonth() + 1),
    day = "" + date.getDate(),
    year = date.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
};
